<template>
  <b-card
    no-body
    aria-controls="overlay-background"
  >
    <b-overlay
      :show="loading"
      :variant="isDarkMode ? 'dark' : 'light'"
    >
      <template v-slot:overlay>
        <loading-logo />
      </template>
      <b-card-body class="p-0">
        <vue-apex-charts
          type="area"
          height="400"
          :options="chartOptions"
          :series="iotData"
        />
      </b-card-body>
    </b-overlay>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BOverlay } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import store from '@/store'
import moment from 'moment-timezone'
import LoadingLogo from '@/views/miscellaneous/LoadingLogo.vue'

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardBody,
    BOverlay,
    LoadingLogo,
  },
  props: {
    iotData: {
      type: Array,
      default: () => [],
    },
    chartColor: {
      type: String,
      default: '#FFF',
    },
    chartUm: {
      type: String,
      default: 'UM',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          locales: [
            {
              name: 'es',
              options: {
                months: [
                  'Enero',
                  'Febrero',
                  'Marzo',
                  'Abril',
                  'Mayo',
                  'Junio',
                  'Julio',
                  'Agosto',
                  'Septiembre',
                  'Octubre',
                  'Noviembre',
                  'Diciembre',
                ],
                shortMonths: [
                  'Ene',
                  'Feb',
                  'Mar',
                  'Abr',
                  'May',
                  'Jun',
                  'Jul',
                  'Ago',
                  'Sep',
                  'Oct',
                  'Nov',
                  'Dic',
                ],
                days: [
                  'Domingo',
                  'Lunes',
                  'Martes',
                  'Miércoles',
                  'Jueves',
                  'Viernes',
                  'Sábado',
                ],
                shortDays: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
                toolbar: {
                  exportToSVG: 'Descargar SVG',
                  exportToPNG: 'Descargar PNG',
                  exportToCSV: 'Descargar CSV',
                  menu: 'Menu',
                  selection: 'Selección',
                  selectionZoom: 'Selección Zoom',
                  zoomIn: 'Acercar',
                  zoomOut: 'Alejar',
                  pan: 'Mover',
                  reset: 'Reiniciar Zoom',
                },
              },
            },
          ],
          defaultLocale: 'es',
          toolbar: {
            show: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
          dashArray: [0, 8, 5],
          curve: 'smooth',
        },
        fill: {
          gradient: {
            enabled: true,
            opacityFrom: 0.55,
            opacityTo: 0,
          },
        },
        markers: {
          size: 3,
          colors: [this.chartColor],
          strokeColors: this.chartColor,
          strokeWidth: 2,
        },
        grid: {
          show: true,
          borderColor: '#90A4AE',
          strokeDashArray: 1,
          position: 'back',
          xaxis: {
            lines: {
              show: false,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: '#000',
            },
            offsetX: -6,
          },
        },
        xaxis: {
          type: 'datetime',
          labels: {
            style: {
              colors: '#000',
            },
            datetimeFormatter: {
              year: 'yyyy',
              month: "MMM 'yy",
              day: 'dd MMM',
              hour: 'HH:mm',
            },
            // format date to dd/MM hh:mm
            formatter(value) {
              return moment.utc(value).local().format('DD/MM hh:mm')
            },
            offsetX: 20,
          },
        },
        colors: [this.chartColor],
        noData: {
          text: 'No hay datos disponibles',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#008FFB',
            fontSize: '16px',
            fontFamily: undefined,
          },
        },
        legend: {
          show: true,
        },
      },
    }
  },
  computed: {
    isDarkMode() {
      return store.state.appConfig.layout.skin === 'dark'
    },
  },
  watch: {
    iotData: {
      handler() {
        // remove markers from chartOptions if length is greater than 100
        if (this.iotData[0].data.length > 100) {
          this.chartOptions = {
            ...this.chartOptions,
            markers: {
              size: 0,
            },
          }
        } else {
          this.chartOptions = {
            ...this.chartOptions,
            markers: {
              size: 3,
              colors: [this.chartColor],
              strokeColors: this.chartColor,
              strokeWidth: 2,
            },
          }
        }
      },
      deep: true,
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";
.apexcharts-toolbar {
  z-index: 0 !important;
}
</style>
